import * as actionTypes from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  success: false
};

// reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTACT_SUCCESS:
      return { success: true };
    case actionTypes.UNSET_CONTACT_SUCCESS:
      return { success: false };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/contact.js